var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M13,20H3a3,3,0,0,1-3-3V9A3,3,0,0,1,3,6H4V4.111A4.062,4.062,0,0,1,8,0a4.061,4.061,0,0,1,4,4.111V6h1a3,3,0,0,1,3,3v8A3,3,0,0,1,13,20ZM3,8A1,1,0,0,0,2,9v8a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H3ZM8,2A2.06,2.06,0,0,0,6,4.111V6h4V4.111A2.06,2.06,0,0,0,8,2ZM8,16a3,3,0,1,1,3-3A3,3,0,0,1,8,16Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,8,12Z",
    transform: "translate(4 2)",
    fill: "#505358"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Password"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Password",
    clipPath: "url(#clip-Password)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M13,20H3a3,3,0,0,1-3-3V9A3,3,0,0,1,3,6H4V4.111A4.062,4.062,0,0,1,8,0a4.061,4.061,0,0,1,4,4.111V6h1a3,3,0,0,1,3,3v8A3,3,0,0,1,13,20ZM3,8A1,1,0,0,0,2,9v8a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1H3ZM8,2A2.06,2.06,0,0,0,6,4.111V6h4V4.111A2.06,2.06,0,0,0,8,2ZM8,16a3,3,0,1,1,3-3A3,3,0,0,1,8,16Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,8,12Z",
    transform: "translate(0 0)",
    fill: "#505358"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.78a59e86d5088d0b7a4cacfe08d3bcfd.svg";
export { ForwardRef as ReactComponent };